import React from "react";
import {
  IconAlertTriangle,
  IconArrowRight,
  IconCheck,
} from "@tabler/icons-react";
import clsx from "clsx";
import Button from "components/Button";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { buildingStore } from "store/Building/BuildingStore";
import { ROUTES_ENUM } from "routes/consts";

export default function MissingEmissionsChart({
  hasReport,
  certification,
  onClose,
}: {
  hasReport: boolean;
  certification: string;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const openOperationalEmissions = () => {
    navigate(
      `/${ROUTES_ENUM.BUILDINGS}/${buildingStore.currentBuilding?.id}/${ROUTES_ENUM.OPERATIONAL_ENERGY}`
    );
    onClose();
  };

  return (
    <div
      className={clsx(
        "flex border p-4 rounded-md w-full items-center flex-col justify-between",
        {
          "border-yellow-100 bg-yellow-50": !hasReport,
          "border-green-100 bg-green-50": hasReport,
        }
      )}
    >
      <div className="flex items-center flex-col">
        <div className="text-lg font-semibold text-gray-800 mb-4 text-center">
          {hasReport
            ? t("certExport.operatingEnergyAdded")
            : t("certExport.operatingEnergyMissing")}
        </div>
        <div
          className={clsx(
            "w-20 h-20 rounded-full flex items-center justify-center mb-4",
            hasReport
              ? "bg-green-100 text-green-600"
              : "bg-yellow-100 text-yellow-700"
          )}
        >
          {hasReport ? (
            <IconCheck size={32} />
          ) : (
            <IconAlertTriangle size={32} />
          )}
        </div>
        <div
          className="text-base font-normal text-gray-800"
          dangerouslySetInnerHTML={{
            __html: hasReport
              ? t("certExport.operatingEnergyAddedDesc", {
                  certification: certification,
                })
              : t("certExport.operatingEnergyMissingDesc", {
                  certification: certification,
                }),
          }}
        ></div>
      </div>
      <Button
        onClick={openOperationalEmissions}
        className={clsx(
          "border-none font-medium text-base mt-3 text-yellow-700",
          {
            hidden: hasReport,
          }
        )}
        type="link"
        width="fit-content"
        trailingIcon={<IconArrowRight />}
      >
        {t("operationalEnergy.openOperationalEmissions")}
      </Button>
    </div>
  );
}
